<template>
    <div class="vehicle-images container-image" v-if="images">
        <div class="images">
            <a class="three" :href="images[type]['large']"
               v-on:mouseenter="displayBigImage(images[type]['large'])"
               v-on:mouseleave="hideBigImage()"
               data-fancybox="gallery" v-for="type in imagesType"
               v-if="type!=='sheet' && images[type]['large']">
                <div class="magnifier"></div>
                <img :data-src="images[type]['large']"
                     alt="">
            </a>
            <div class="two container-thumbnail" v-if="extra && extra.length">
                <a v-for="(image, i) in extra" class="six" :href="image['large']"
                   v-on:mouseenter="displayBigImage(image['large'])"
                   v-on:mouseleave="hideBigImage()"
                   data-fancybox="gallery">
                    <div class="magnifier"></div>
                    <img :data-src="image['large']"
                         alt="">
                </a>
            </div>
        </div>
        <div class="sheet">
            <div class="over-image" :class="showBigImage ? 'show' : ''">
                <img v-if="bigImageUrl" :src="bigImageUrl" alt="" id="hoverImage">
            </div>
            <a class="three" :href="images['sheet']['large']"
               data-fancybox="gallery"
               v-if="images['sheet']['large']">
                <div class="magnifier"></div>
                <img :data-src="images['sheet']['large']" height="500"
                     alt="">
            </a>
        </div>
    </div>
</template>
<script>

export default {
    props: [
        'images',
        'extra',
    ],
    data() {
        return {
            showBigImage: false,
            bigImageUrl: null,
            imagesType: ['sheet', 'front', 'back', 'interior'],
        }
    },
    created() {
        setTimeout(() => {
            this.loadImages()
        }, 1500)
    },
    mounted() {
        const screenWidth = window.innerWidth;
        $('[data-fancybox]').fancybox({
            loop : true,
            width: screenWidth,
        });
    },
    methods: {
        displayBigImage(url) {
            this.showBigImage = true;
            this.bigImageUrl = url;
        },
        hideBigImage() {
            this.showBigImage = false;
        },
        loadImages() {
            const imageElement = document.querySelectorAll('#description-vehicle img');
            imageElement.forEach(function (elm) {
                if (elm && elm.dataset.src) {
                    elm.addEventListener("load", () => {
                        setTimeout(() => elm.classList.add("loaded"), 100);
                    });
                    // elm.addEventListener("error", () => console.log("error"));
                    elm.src = elm.dataset.src;
                }
            })
        }
    }


}
</script>





// WEBPACK FOOTER //
// resources/js/components/Common/VehicleStockImages.vue